import { React, useEffect, useState } from "react";
import "./Facts.css";
import Odometer from "react-odometerjs";

const Facts = () => {
  const [exprerience, setExperience] = useState(0);
  const [projects, setProjects] = useState(0);
  const [reviews, setReviews] = useState(0);
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setExperience(3);
      setProjects(199);
      setReviews(100);
    }, 1500);
    return () => {
      clearTimeout(timeoutId);
    };
  }, []);
  return (
    <div className="fact__container">
      <div className="fact__item">
        <div className="count__container">
          <Odometer value={exprerience} />
          <span className="indicator">+</span>
        </div>
        <p className="name">Років досвіду</p>
      </div>
      <div className="fact__item">
        <div className="count__container">
          <Odometer value={projects} />
          <span className="indicator">+</span>
        </div>
        <p className="name">Проєктів</p>
      </div>
      <div className="fact__item">
        <div className="count__container">
          <Odometer value={reviews} />
          <span className="indicator">+</span>
        </div>
        <p className="name">Відгуків</p>
      </div>
    </div>
  );
};

export default Facts;
